<script setup lang="ts">
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { useStation } from '@/store/station';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const station = useStation();
const { name } = useDisplay();

const card_width = computed((): string => {
  switch (name.value) {
    case "xs":
    case "sm":
      return "w-100";
    default:
      return "w-50";
  }
});

</script>

<template>
  <v-dialog
    :model-value="station.is_offline && !station.test_mode"
    no-click-animation
    persistent
    z-index="1500"
    style="background-color: rgba(0, 0, 0, 0.4)"
  >
    <v-container class="pa-0" fill-height fluid>
      <v-col>
        <v-row class="justify-center">
          <v-card
            :class="`bg-yellow ${card_width} mx-3`"
            style="border-style: dashed; border-width: 4px; border-color: black;"
          >
            <v-card-text class="text-black justify-center align-center text-center">
              <p class="pb-3">
                <span class="text-uppercase text-body-1">{{ t("charging_station_offline") }}</span>
              </p>
              <p class="pb-3">
                <span class="text-body-2">{{ t("client_message") }}</span>
              </p>
              <p class="pb-3">
                <span class="text-body-2">{{ t("report") }}</span>
              </p>
            </v-card-text>
          </v-card>
        </v-row>
      </v-col>
    </v-container>
  </v-dialog>
</template>

<i18n lang="yml">
en:
  "charging_station_offline": "This charging station is offline"
  "client_message": "This charging station is offline or deactivated, and charging cannot be activated."
  "report": "Please report to the owner of the charging station"
it:
  "charging_station_offline": "Questo punto di ricarica è offline"
  "client_message": "Questo punto di ricarica é offline o disattivato, e la ricarica non puo' essere attivata."
  "report": " Siete pregati di segnalarlo ai proprietari della stazione."
fr:
  "charging_station_offline": "Cette borne de recharge est hors ligne"
  "client_message": "Cette borne de recharge est hors ligne ou désactivée et la recharge ne peut pas être activée."
  "report": "Veuillez vous présenter au propriétaire de la borne de recharge"
de:
  "charging_station_offline": "Diese Ladestation ist offline"
  "client_message": "Dieser Ladepunkt ist offline oder deaktiviert und der Ladevorgang kann nicht aktiviert werden."
  "report": "Bitte melden Sie sich beim Besitzer der Ladestation"
nl:
  "charging_station_offline": "Dit laadstation is offline"
  "client_message": "Dit laadpunt is offline of gedeactiveerd en het opladen kan niet worden geactiveerd."
  "report": "Meld dit dan bij de eigenaar van het laadstation."
</i18n>

<style scoped lang="scss">
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
